import React, { FC, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router";
import { Navbar, Select } from "@postenbring/hedwig-react";

import Translated from "../infrastructure/translation/Translated";
import { LanguageLinks } from "../infrastructure/translation/translate";
import styles from "./Header.module.css";
import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { findUriIfExists } from "../infrastructure/entrypoint/link";
import {
  useOrganizationIfSelected,
  useOrganizations,
} from "../infrastructure/organization/OrganizationContext";
import { useRootPath } from "../infrastructure/translation/useRootPath";
import { useTranslate } from "../infrastructure/translation/useTranslate";

const Header: FC = (): React.ReactElement => {
  const entrypoint = useEntrypointContext();
  const [showLanguageMenu, setShowLanguangeMenu] = useState(false);
  const organization = useOrganizationIfSelected();
  const allOrganizations = useOrganizations();
  const navigate = useNavigate();
  const rootPath = useRootPath();
  const translate = useTranslate();

  const hasLogout = entrypoint && findUriIfExists("logout", entrypoint._links);

  const logOut = () => {
    const url = findUriIfExists("logout", entrypoint._links);
    if (!url) {
      console.error("Kunne ikke logge ut!");
    } else {
      window.location.href = url;
    }
  };

  const handleOrgChange = (orgnr: string) => {
    if (orgnr && orgnr !== organization?.organization.orgnr) {
      navigate(`${rootPath}/organization/${orgnr}`);
    }
  };

  const showOrgDropdown = organization && allOrganizations.length > 1;

  return (
    <Navbar variant="service">
      <Navbar.LogoAndServiceText variant="service" asChild>
        <RouterLink to={rootPath}>Digipost</RouterLink>
      </Navbar.LogoAndServiceText>
      <Navbar.Navigation>
        {showOrgDropdown && (
          <Navbar.Item>
            <Select
              aria-label={translate("header.select_organization")}
              size="small"
              value={organization.organization.orgnr}
              onChange={(e) => handleOrgChange(e.target.value)}
            >
              {allOrganizations.map((orgRep) => (
                <option
                  key={orgRep.organization.orgnr}
                  value={orgRep.organization.orgnr}
                >
                  {orgRep.organization.name}
                </option>
              ))}
            </Select>
          </Navbar.Item>
        )}
        <div className={styles.languageMenu}>
          <Navbar.ButtonItem
            onClick={() => setShowLanguangeMenu((prevState) => !prevState)}
            aria-expanded={showLanguageMenu}
          >
            <Translated textKey="header.langauge" />
          </Navbar.ButtonItem>
          {showLanguageMenu && (
            <ul className={styles.headerLanguageList}>
              <LanguageLinks style={styles.headerLanguageLink} />
            </ul>
          )}
        </div>
        {hasLogout && (
          <Navbar.ButtonItem onClick={logOut}>
            <Translated textKey="header.logout" />
          </Navbar.ButtonItem>
        )}
      </Navbar.Navigation>
    </Navbar>
  );
};

export default Header;
